/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'; // eslint-disable-line

import { Button, Divider, Grid, Paper, Typography, withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import styles, { StyledComponent } from '../../../styles/styles';
import { State } from '../../../redux/root-reducer';
import {
    Decision,
    getRaDeathAssessmentDecisions,
} from '../../../assessment/decisions/ra-death/ra-death-assessment-details-reducer';
import {
    Dependant,
    getDependants,
    getDependantsRelationship,
    getLinkedBeneficiaries,
    getSpouses,
} from '../../../assessment/synopsis/ra-death/dependants/reducer';
import { formatPercent, getCodeDescription, getFullName } from '../../../shared-functions';
import { Code } from '../../../lookups';
import { Cached } from '@material-ui/icons';
import { ButtonWrapper } from '../../../forms';
import { UpdateBeneficiaries, updateBeneficiariesAction } from '../../actions/update-beneficiaries';

interface OwnerProps {
    updateBeneficiaries: UpdateBeneficiaries;
}
interface StateProps {
    readonly decision: Decision[];
    readonly dependants: Dependant[];
}

type Props = OwnerProps & StateProps & StyledComponent;

const compassBeneficiaryDetailsView: React.FunctionComponent<any> = ({
    classes,
    decision,
    dependants,
    updateBeneficiaries,
}: Props) => {
    if (decision.length === 0) {
        return null;
    }

    const currentDecision = decision[0];
    let totalAllocation = 0;
    return (
        <Paper>
            <Typography
                variant="h6"
                style={{ marginLeft: 20, marginBottom: 10 }}
                className={classes.spacedTypography}
            >
                Beneficiaries/Dependents/Payees
            </Typography>
            <Typography
                variant="body2"
                color="textSecondary"
                component="div"
                style={{
                    marginTop: '10px',
                    display: 'flex',
                    backgroundColor: '#E6EDFF',
                    height: '27px',
                    width: '45%',
                }}
            >
                <span
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 20,
                        height: 12,
                        backgroundColor: '#007BFF',
                        color: 'white',
                        borderRadius: '40%',
                        marginLeft: 18,
                        fontSize: 14,
                        marginTop: '5px',
                        marginRight: 14,
                    }}
                >
                    i
                </span>
                Please ensure that Payees have been updated before proceeding to payments
            </Typography>
            <Grid item xs={12} lg={12} justify="flex-end">
                <ButtonWrapper>
                    <Button
                        id="AddDirectiveItem"
                        color="secondary"
                        style={{ marginBottom: 30, marginLeft: '80%', textTransform: 'none' }}
                        onClick={() => updateBeneficiary()}
                    >
                        <Cached />
                        Update Payee on Compass
                    </Button>
                </ButtonWrapper>
            </Grid>
            <Grid container justify="space-between" style={{ marginLeft: 20, marginBottom: 20 }}>
                <Grid item xs={3}>
                    <Typography variant="subtitle2">Beneficiary/Dependant</Typography>
                </Grid>
                <Grid item xs={1}>
                    <Typography variant="subtitle2">Age</Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="subtitle2">Relationship</Typography>
                    <Typography variant="subtitle2">to Life Assured</Typography>
                </Grid>
                <Grid item xs={1}>
                    <Typography variant="subtitle2">Cash</Typography>
                    <Typography variant="subtitle2">Lump Sum(%)</Typography>
                </Grid>
                <Grid item xs={1}>
                    <Typography variant="subtitle2">RA</Typography>
                    <Typography variant="subtitle2">Annuity(%)</Typography>
                </Grid>
                <Grid item xs={1}>
                    <Typography variant="subtitle2">Compulsory</Typography>
                    <Typography variant="subtitle2">Annuity(%)</Typography>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="subtitle2">Allocation</Typography>
                </Grid>
            </Grid>
            {currentDecision.recommendations.map((recommendation, index) => {
                const dependant = dependants.find(d => d.id === recommendation.dependantId);
                const spouses = getSpouses(dependants);
                const { name, age, relationship, childOf } = getDependantDetails(
                    dependant,
                    spouses
                );
                totalAllocation += recommendation.allocation;
                const cash = recommendation.cash;
                const raAnnuity = recommendation.raAnnuity;
                const compulsoryAnnuity = recommendation.compulsoryAnnuity;

                return (
                    <Grid
                        container
                        justify="space-between"
                        key={`recommendation_${index}`}
                        style={{ marginLeft: 20 }}
                    >
                        <Grid item xs={3}>
                            <Typography>{name}</Typography>
                            {childOf && childOf !== ' ' && (
                                <Typography style={{ fontSize: '0.75rem', fontWeight: 300 }}>
                                    {childOf}
                                </Typography>
                            )}
                        </Grid>
                        <Grid item xs={1}>
                            <Typography>{age}</Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography>{relationship}</Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <Typography>{cash}</Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <Typography>{raAnnuity}</Typography>
                        </Grid>
                        <Grid item xs={1}>
                            <Typography>{compulsoryAnnuity}</Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography style={{ marginRight: 40 }}>
                                {formatPercent(recommendation.allocation / 100)}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider
                                style={{
                                    backgroundColor: '#8B92A7',
                                    marginRight: 38,
                                    marginLeft: -4,
                                    marginTop: 4,
                                    marginBottom: 4,
                                }}
                            />
                        </Grid>
                    </Grid>
                );
            })}
            <Grid item xs={12} container justify="flex-end">
                <Grid item xs={4} container justify="flex-end">
                    <Typography style={{ marginRight: 130 }}>
                        {formatPercent(totalAllocation / 100)}
                    </Typography>
                </Grid>
            </Grid>
        </Paper>
    );

    function updateBeneficiary() {
        updateBeneficiaries();
    }
};

function getDependantDetails(dependant?: Dependant, spouses?: Code<string>[]) {
    if (dependant) {
        if (dependant.dependantType === 'Organisation') {
            const organisationDetails = dependant.organisationDetails || {};
            return {
                name: organisationDetails.companyName || '',
                age: '-',
                relationship: getCodeDescription(
                    'relationship',
                    organisationDetails.relationshipToLifeAssured
                ),
            };
        }
        const personalDetails = dependant.personalDetails || {};
        let childOf = ' ';
        if (dependant.relationship === 'MinorChild') {
            const linkedParents = getLinkedBeneficiaries(spouses || [], dependant.parent);
            if (Array.isArray(linkedParents) && linkedParents.length > 0) {
                childOf = `${getDependantsRelationship(dependant.relationshipDescription)} of ${
                    linkedParents[0]
                }`;
            } else {
                childOf = 'Parent not listed';
            }
        }
        return {
            name: getFullName(personalDetails),
            age: personalDetails.age ? personalDetails.age.toString() : '-',
            relationship: getCodeDescription('relationship', dependant.relationshipDescription),
            childOf,
        };
    }
    return {
        name: 'Unknown (deleted)',
        age: '-',
        relationship: '-',
        childOf: ' ',
    };
}

const mapStateToProps = (state: State) => {
    return {
        decision: getRaDeathAssessmentDecisions(state),
        dependants: getDependants(state),
    };
};

const mapDispatchToProps = {
    updateBeneficiaries: updateBeneficiariesAction,
};

export const CompassBeneficiaryDetailsView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(compassBeneficiaryDetailsView));
